<script>
  import { filter, size } from "lodash-es";
  import { uuid } from '@parkingboss/utils';

  import Permit from "./boss/Permit.svelte";

  export let id;
  export let media;
  export let permits;
  export let propertyId;

  function getCommonId(id) {
    const parsedUid = uuid.parse(id);
    return uuid.toUuid32(parsedUid);
  }

  function validateMediaForLocation(id, media, permits) {
    if (!id) return null;
    const commonId = getCommonId(id);
    return {
      id: commonId,
      media: media.items[commonId],
      permits: filter(permits.items, {
        type: "permit",
        media: {
          id: commonId
        }
      })
    };
  }

  function checkPermits(result) {
    return result && size(result.permits) > 0;
  }

  $: result = validateMediaForLocation(id, media, permits);
  $: hasPermits = checkPermits(result);
</script>

{#if result}
  <section class:valid={hasPermits && result.media}>
    <header>
    {#if !result.media}
      <h1>Not Valid At This Location</h1>
    {:else if !hasPermits}
      <h1>Inactive {result.media.title}</h1>
    {:else}
      <h1>Active {result.media.title}</h1>
    {/if}
    </header>
    {#if result.media}
      <dl><dt>{result.media.description}</dt><dd><data class="media id {result.media.format}" value="{result.media.id}">{result.media.display}</data></dd></dl>
      
    {/if}

    {#if hasPermits}
        <ul>
        {#each result.permits as permit}
            <li><Permit {permit} /></li>
        {/each}
        </ul>
    {/if}
    <footer>
      <a href="/{propertyId}">Done</a>
    </footer>
  </section>
{/if}
